export default __webpack_public_path__ + "static/media/PHÂN HỆ BÁO CÁO.73a6b7c1.pdf";